<template>
  <section class="DocumentContent">
    <div class="container">
      <div class="content">
        <h1 class="small" v-if="content.title">{{ content.title }}</h1>
        <PrismicRichText
          class="text"
          :field="content.content"
          v-if="content.content"
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
// import { computed } from "vue";
// const computedExample = computed(() => 1);
defineOptions({
  name: "DocumentContent",
});

const props = defineProps({
  content: {
    type: Object,
    default: () => {},
  },
});
const store = useLayoutStore();
const IS_Mobile = computed(() => store.IS_Mobile);
const IS_Tablet = computed(() => store.IS_Tablet);
const IS_Tablet2 = computed(() => store.IS_Tablet2);
</script>

<style lang="scss" scoped>
.DocumentContent {
  position: relative;
  padding-top: toRem(102);
  padding-bottom: toRem(90);
  @media (max-width: $mobile) {
    padding-top: toRem(70);
    padding-bottom: toRem(30);
  }
}
.content {
  width: toRem(820);
  max-width: 100%;
  margin: auto;
  color: #909090;
  :deep() {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-style: normal;
      margin-bottom: toRem(14);
      font-weight: 600;

      font-family: $main-font;
      margin-top: toRem(30);
      @media (max-width: $mobile) {
        font-weight: 400;
      }
    }
    p {
      margin-bottom: toRem(14);
    }
    h1 {
      margin-top: 0;
      margin-bottom: toRem(61);
    }
    h2 {
      font-size: toRem(44);
      line-height: 130%;
      margin-bottom: toRem(30);
      margin-top: toRem(60);
    }
    h3 {
      font-size: toRem(28);
      margin-top: toRem(28);
      line-height: 130%;
      margin-top: toRem(32);
    }
    h4 {
      font-size: toRem(20);
      line-height: 160%;
      margin-top: toRem(14);
      margin-bottom: toRem(10);
      @include minTablet {
        padding-right: toRem(40);
      }
    }
    .block-img,
    pre {
      margin-bottom: toRem(14);
      margin-top: toRem(14);
    }
    pre {
      color: $orange-second;
    }

    ul,
    ol {
      margin-bottom: toRem(14);
      margin-top: toRem(14);
      li {
        position: relative;
        padding-left: toRem(24);
        margin-bottom: toRem(7);
      }
    }
    ul li {
      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: toRem(9);
        width: toRem(8);
        height: toRem(8);
        border-radius: 50%;
        background: $orange-second;
      }
    }
    ol {
      counter-reset: list-counter;
      li {
        counter-increment: list-counter;
        padding-left: toRem(36);
        &::before {
          content: counter(list-counter) ". ";
          position: absolute;
          left: toRem(0);
          top: 0;
          bottom: 0;
          margin: auto;
          width: toRem(32);
          text-align: center;
          color: $orange-second;
        }
      }
    }
    @media (max-width: $mobile) {
      h1 {
        font-weight: 400;
        font-size: toRem(40);
        line-height: 107%;
        margin-bottom: toRem(50);
      }
      h2 {
        font-size: toRem(30);
        line-height: 107%;
        margin-top: toRem(63);
        margin-bottom: toRem(28);
        &:first-child {
          margin-top: toRem(50);
          margin-bottom: toRem(32);

          & + h3 {
            margin-top: toRem(32);
            margin-bottom: toRem(20);
          }
        }
      }
      h3 {
        font-size: toRem(20);
        margin-top: toRem(28);
        line-height: toRem(26);
      }
      h4 {
        font-size: toRem(20);
        line-height: toRem(26);
      }
      ul,
      ol {
        li {
          margin-bottom: toRem(16);
        }
      }
    }
  }
  .text > *:last-child {
    margin-bottom: 0;
  }
}
</style>
